import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomerViewComponent } from './customerview.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [CustomerViewComponent],
  exports: [
    CustomerViewComponent
  ],
  providers: [
  ]
})
export class CustomerViewComponentModule { }
